<mat-toolbar
  color="primary"
  class="apearAnimation flex-row flex content-between relative rounded-md"
>
  <div class="absolute left-0 pl-2">
    <span class="font-semibold">Cuadro de ingresos</span>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <div
    class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2"
  >
    <mat-form-field appearance="outline" style="width: 400px">
      <mat-label>Periodo de busqueda</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Fecha desde" />
        <input matEndDate [(ngModel)]="endDate" placeholder="Fecha hasta" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Disciplina</mat-label>
      <mat-select [(ngModel)]="disciplinaSelect">
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option
          *ngFor="let disciplinaTmp of lstDisciplinas"
          [value]="disciplinaTmp.id"
        >
          {{ disciplinaTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!--       <mat-form-field appearance="outline" 
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Club</mat-label>
      <mat-select
        [(ngModel)]="clubSelect"
    
      >
        <mat-option *ngFor="let clubTmp of lstClubes" [value]="clubTmp.id">
          {{ clubTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <button
      style="margin-left: 10px"
      (click)="buscar()"
      mat-raised-button
      color="primary"
    >
      Buscar
    </button>
  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <div
    class="mat-elevation-z0"
    *ngIf="!isLoadingResults && data"
    style="background-color: rgb(240, 240, 240)"
  >
    <div class="flex flex-nowrap gap-x-0.5">
      @for (item of data.headers; track item) {
      <div
        class="flex justify-center content-center items-center m-2 rounded-md shadow-md bg-red-500 hover:shadow-red-500/40 w-32 min-w-32"
      >
        <span class="text-white self-center">
          {{ item }}
        </span>
      </div>
      }
    </div>

    @for (item of data.resultados; track item) {
    <div class="flex flex-nowrap gap-x-0.5">
      <div
        class="flex flex-col justify-center content-center items-center m-2 rounded-md shadow-md bg-stone-500 hover:shadow-stone-500/40 w-32 min-w-32"
      >
        <p class="text-white">
          {{ item.nombre }}
        </p>
        <p class="text-white">
          {{ item.documento }}
        </p>
      </div>

      @for (ingreso of item.data; track ingreso) { @switch(ingreso.resultado){
      @case(0) {
      <div
        class="flex justify-center content-center items-center m-2 rounded-md shadow-md bg-slate-200 hover:shadow-slate-500/40 w-32 min-w-32"
      >
        <span class="text-black self-center"> Sin registro </span>
      </div>

      } @case(1) {
      <div
        class="flex flex-col justify-center content-center items-center m-2 rounded-md shadow-md bg-orange-400 hover:shadow-orange-500/40 w-32 min-w-32"
      >
        <p class="text-black self-center">
          No ingresa
        </p>
        <p class="text-black self-center">
          código: {{ ingreso.codNoIngreso }}
        </p>
        <p>
          {{ ingreso.fecha | date : "HH:mm a" }}
        </p>
      </div>

      } @case(2) {
      <div
        class="flex flex-col justify-center content-center items-center m-2 rounded-md shadow-md bg-sky-500 hover:shadow-sky-500/40 w-32 min-w-32"
      >
        <p class="text-white self-center">Ingresa</p>

        <p class="text-sm text-white self-center">
          {{ ingreso.fecha | date : "HH:mm a" }}
        </p>
      </div>

      } } }
    </div>
    }
  </div>
</div>
